import { type OneOfAvailableLocalizations, availableLocalizationsList } from './LocalizationProvider';
import { type BackendProduct } from '@/utils/api/schema/plansSchema';

const localizePlanName = (backendPlan: BackendProduct): Record<OneOfAvailableLocalizations, string> => {
  const localizedName: Record<string, string> = {};

  for (const locale of availableLocalizationsList) {
    localizedName[locale] = backendPlan.data.title[locale] ?? backendPlan.name;
  }

  return localizedName;
};

export { localizePlanName };
